<mat-card class="content-card">
  <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </mat-card-header>
  <h2>{{ getTitle }}</h2>
  <p>Add or configure an org's calendar.</p>
  <pre class="no-calendar-message" *ngIf="!initialCalendarsConfig?.length">
    <mat-icon color="primary">info</mat-icon> No calendar is configured. Add one below.</pre>

  <form [formGroup]="calendarsForm" *ngIf="!loading">
    <div formArrayName="calendars" *ngIf="calendars?.controls">
      <div class="form" *ngFor="let calendar of calendars?.controls; let i = index" [formGroupName]="i">
        <div class="row">        
          <mat-form-field appearance="outline">
            <mat-label>Calendar type</mat-label>
            <mat-select formControlName="type"
            (valueChange)="onSelectType($event, i, calendar.value)">
              <mat-option
                *ngFor="let option of calendarTypesSelectOptions"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="name-field">
            <mat-form-field appearance="outline">
              <mat-label>Calendar Name</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <div *ngIf="calendar?.get('name').errors?.required && calendar?.get('name').touched">
              <span class="text-danger">Please enter a name</span>
            </div>
          </div>
          <button
            class="remove-button"
            mat-raised-button
            (click)="removeCalendar(i)"
            [disabled]="i === 0 && calendars.controls.length === 1">
            &nbsp;Remove Calendar
          </button>
        </div>

        <ng-container *ngIf="calendar.get('type')?.value && calendar.get('type')?.value !== CalendarTypes.GOOGLE">
          <mat-form-field appearance="outline" *ngIf="calendar?.get('frUrl')">
            <mat-label>FR URL</mat-label>
            <input matInput formControlName="frUrl" />
            <div *ngIf="calendar?.get('frUrl')?.errors?.pattern && calendar?.get('frUrl')?.value">
              <span class="text-danger">Please enter a valid URL (no spaces allowed)</span>
            </div>
          </mat-form-field>
      
          <mat-form-field appearance="outline" *ngIf="calendar?.get('frUrl')">
            <mat-label>EN URL</mat-label>
            <input matInput formControlName="enUrl" />
            <div *ngIf="calendar?.get('enUrl')?.errors?.pattern && calendar?.get('enUrl')?.value">
              <span class="text-danger">Please enter a valid URL (no spaces allowed)</span>
            </div>
          </mat-form-field>
        </ng-container>

          <ng-container *ngIf="calendar.get('type')?.value && calendar.get('type')?.value === CalendarTypes.GOOGLE">
            <div class="form-google">
              <div class="section-google">
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Client ID</mat-label>
                    <input matInput type="text" formControlName="client_id" />
                  </mat-form-field>
            
                  <mat-form-field appearance="outline">
                    <mat-label>Project ID</mat-label>
                    <input matInput type="text" formControlName="project_id" />
                  </mat-form-field>
                </div>
            
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Auth URI</mat-label>
                    <input matInput type="text" formControlName="auth_uri" />
                  </mat-form-field>
            
                  <mat-form-field appearance="outline">
                    <mat-label>Token URI</mat-label>
                    <input matInput type="text" formControlName="token_uri" />
                  </mat-form-field>
                </div>
            
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Auth provider cert URL</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="auth_provider_x509_cert_url"
                    />
                  </mat-form-field>
            
                  <mat-form-field appearance="outline">
                    <mat-label>Client secret</mat-label>
                    <input matInput type="text" formControlName="client_secret" />
                  </mat-form-field>
                </div>
            
                <div class="row">
                  <mat-form-field appearance="outline" class="chips-form-field">
                    <mat-label>Redirect URIs</mat-label>
                    <mat-chip-list
                      #redirectUriChipList
                      aria-label="Redirect URIs"
                      multiple
                      formControlName="redirect_uris"
                    >
                      <mat-chip
                        *ngFor="let uri of calendar.get('redirect_uris')?.value"
                        [selected]="uri"
                        [value]="uri"
                        (removed)="removeRedirectUri(uri, i)"
                      >
                        {{ uri }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                    </mat-chip-list>
                    <input
                      placeholder="Add redirect URI..."
                      [matChipInputFor]="redirectUriChipList"
                      (matChipInputTokenEnd)="addRedirectUri($event, i)"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div formGroupName="token" class="section-google">
                <div class="row">
                  <h3>Token</h3>
                </div>
          
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Access token</mat-label>
                    <input matInput type="text" formControlName="access_token" />
                  </mat-form-field>
          
                  <mat-form-field appearance="outline">
                    <mat-label>Expires in</mat-label>
                    <input matInput type="text" formControlName="expires_in" />
                  </mat-form-field>
                </div>
          
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Token type</mat-label>
                    <input matInput type="text" formControlName="token_type" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Scope</mat-label>
                    <input matInput type="text" formControlName="scope" />
                  </mat-form-field>
                </div>
          
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Refresh token</mat-label>
                    <input matInput type="text" formControlName="refresh_token" />
                  </mat-form-field>
                </div>
              </div>
            </div>          
          </ng-container>
      </div>
    </div>
  </form>



  <mat-card-footer>
    <a mat-raised-button (click)="addCalendar()"> &nbsp;Add new calendar </a>
    <a mat-raised-button (click)="resetConfig()"> &nbsp;Reset form </a>

    <button
      mat-raised-button
      color="primary"
      type="submit"
      (click)="handleSubmitClicked()"
      [disabled]="loading || syncLoading"
    >
      <mat-icon>save</mat-icon>
      &nbsp;Save
    </button>
  </mat-card-footer>
</mat-card>


<mat-card *ngIf="initialCalendarsConfig?.length">
  <h2>More actions</h2>
  <mat-card-content class="more-content">
    <div class="row">
      <button
        mat-raised-button
        color="primary"
        (click)="syncCalendar()"
        [disabled]="syncLoading || loading"
      >
        <mat-icon>update</mat-icon>
        &nbsp;Sync calendar
      </button>
      <pre>{{syncResponse}}</pre>
    </div>
    <div>
      <!-- Remove [disabled]="true" below to activate functionality (everything is already done) -->
      // TODO: Implement backend ->
      <button
        mat-raised-button
        color="warn"
        (click)="handleDeleteCalendar()"
        [disabled]="true"
      >
        <mat-icon>delete</mat-icon>
        &nbsp;Delete existing config
      </button>
    </div>
  </mat-card-content>
</mat-card>
